var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productExa"},[_vm._m(0),_c('div',{staticClass:"swiper"},[_c('product-swiper')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title",attrs:{"data-aos":"fade-up"}},[_c('div',{staticClass:"title"},[_vm._v("政企信赖之选"),_c('br'),_vm._v("让数字化触手可及")]),_c('div',{staticClass:"fakeTitle"},[_vm._v(" 使用前沿先进技术，"),_c('br'),_vm._v("完美解决用户痛点，打造经典案例 ")])])
}]

export { render, staticRenderFns }